import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomGridViewService {

  getCustomGridView = new BehaviorSubject<any>(null);
  constructor() { }
  getData(state: BehaviorSubject<any>) {
    return state.value;
  }

  updateData(state: BehaviorSubject<any>, data: any) {
    state.next(data);
  }
}
